import {
  AfterContentChecked,
  AfterContentInit,
  AfterViewChecked,
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {TranslationService} from '../../../core/services/translation.service';
import {BaseDataService} from '../../../core/services/base-data.service';
import {Subscription} from 'rxjs';
import {Bonus, BonusType} from '../../../data/models/bonus.model';
import {SelectedGift} from '../../../data/models/selected-gift.model';
import {MatDialog} from '@angular/material/dialog';
import {BonusDetailComponent} from './bonus-detail/bonus-detail.component';
import {OfferService} from '../../../data/services/offer.service';
import {Offer} from '../../../data/models/offer.model';
import {isDigital} from '../../../core/utils/offer-utils';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {LoginService} from '../../../core/components/login/login.service';
import {UserData} from '../../../data/models/user-data.model';
import {HupSubscriptionsService} from '../../../data/services/hup-subscriptions.service';
import {CustomValidators} from '../../../core/validators';
import {BaseData} from '../../../data/models/base-data.model';
import {OfferPrice} from '../../../data/models/price.model';
import {LoginComponent} from '../../../core/components/login/login.component';
import {PaymentProvider, PaymentTransactionModel} from '../../../core/components/onlinepayment/paymentTransaction.model';
import {FormOfPayment} from "../../../data/models/formOfPayment.model";
import {ConfigService} from "../../../core/services/config.service";
import {SnackbarService} from "../../../core/services/snackbar.service";
import {CssPropertiesEnum} from "../../../core/models/css-properties.enum";
import {VHostService} from "../../../core/services/v-host.service";
import {NavigationCommand, NavigationService} from "../../../data/services/navigation.service";
import {MoveService} from "../../../data/services/move.service";
import {PaymentProviderService} from "../../../core/services/payment-provider.service";
import {DatePipe, DecimalPipe, isPlatformBrowser} from '@angular/common';
import {SubExtendedData} from "../../../data/models/sub-extended-data.model";
import {SubExtendedDataField} from "../../../data/models/sub-extended-data-field";
import {OrderTrackingService} from "../../../core/services/order-tracking.service";
import {GtmEnum} from "../../../core/models/gtm.enum";
import {ImageService} from "../../../core/services/image.service";
import {StepperOrientation, StepperSelectionEvent} from "@angular/cdk/stepper";
import {OrderResultModel} from "../../../data/models/orderResult.model";
import {MatStepper} from "@angular/material/stepper";
import {PaymentService} from "../../../data/services/payment.service";
import {AddressCode} from "../../../data/models/address-code.model";
import {ClientType} from "../../../data/models/client-type.model";
import {ScriptLoaderService} from '../../../core/services/script-loader.service';
import {ImageHandler} from "../../../image-handler.service";
import {HouseNoPipe} from '../../../core/pipes/houseno.pipe';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {BankAccountPipe} from '../../../core/pipes/bank-account.pipe';
import {catchError} from "rxjs/operators";
import {DateAdapter} from "@angular/material/core";

@Component({
  selector: 'app-offer-detail',
  templateUrl: './offer-detail.component.html',
  styleUrls: ['./offer-detail.component.scss']
})
export class OfferDetailComponent implements OnInit, AfterViewChecked, OnDestroy, AfterViewInit, AfterContentInit, AfterContentChecked {
  @ViewChild('login') loginComponent: LoginComponent;
  @ViewChild('stepper') stepper: MatStepper;

  showOnlinePayment: boolean = false;
  needIbanBic: boolean = false;
  needInvoiceMailAddress: boolean = false;
  askForBirthday: boolean = true; //Dieser Wert hängt von der Konfig 'offer.askForBirthday' oder von checkCreditRequired-Property des Bonus ab
  askForBirthdayConst: boolean = true; // Konstante zum Speichern von dem Konfig-Wert 'offer.askForBirthday'
  isBirthdayRequired: boolean = false; // Dieser Wert hängt von der Konfig 'requiredFields.addr.birthday' oder von checkCreditRequired-Property des Bonus ab
  isBirthdayRequiredConst: boolean = false; // Konstante zum Speichern von dem Konfig-Wert 'requiredFields.addr.birthday'
  askForPaymentAccountHolder: boolean = false;
  askForPhone: boolean = false;
  isPhoneRequired: boolean = false;
  askForEmail: boolean = true;
  countries: BaseData[] = [];
  optinResult: Map<number, boolean> = new Map<number, boolean>;

  CssPropertiesEnum = CssPropertiesEnum;

  billingAddressFilled: boolean = false;
  bonusAddressFilled: boolean = false;

  colAmount: number = 5;
  offer: Offer;
  bonusFormGroup: FormGroup;
  addressFormGroup: FormGroup;
  paymentFormGroup: FormGroup;
  loginFormGroup: FormGroup;

  upsellingFormGroup: FormGroup;
  isEditable: boolean = true;
  offerPrice: OfferPrice[];
  authSub: Subscription;
  isAuthenticated: boolean = false;
  errorsArr: string[] = [];

  isLoadingUserData: boolean = false;
  isLoadingView: boolean = false;
  offerFound: boolean = true;
  userData: UserData;

  maxPoints: number = 12; // TODO: load
  usedPoints: number = 0;
  freeBonusPoints: number = this.maxPoints;
  showBonusPoints: boolean = false;

  bonusSelection: boolean = true;
  moneyBonusSelected: boolean = false;
  nonMoneyBonusWithClientCoPaymentSelected: boolean = false;
  minDate: Date = new Date();
  maxDate: Date;

  dateRange: boolean = false;

  formsOfPayment: FormOfPayment[] = [];
  allFormsOfPayment: BaseData[] = [];
  paymentFrequencies: BaseData[] = [];
  allPaymentFrequencies: BaseData[] = [];
  salutations: AddressCode[] = [];
  clientTypes: ClientType[] = [];

  bonuses: Bonus[] = [];
  bonusesToShow: Bonus[] = [];
  additionalData: SubExtendedDataField[] = [];
  leftSide: number = 66;
  rightSide: number = 33;

  @ViewChild('offerContainer') offerContainer: ElementRef;

  stepperOrientation: StepperOrientation = 'horizontal';

  selectedBonus: Bonus []= [];
  selectedBillingAddress = null;
  selectedBonusAddress = null;
  selectedDeliveryAddress = null;

  selectedFormOfPayment = null;
  selectedPaymentFrequency = null;
  selectedStartDate = null;
  redirectUrl = null;
  clientNoUrl = null;
  startDateUrl = null;
  urlParams : Map<string, string> = new Map<string, string>;
  isWinback: boolean = false;

  calculatingPrice: boolean = false;
  creatingOrder: boolean = false;
  hideLoginBox = false;
  onlyOneAddress = false;

  checkBoxes = false;

  maxBonuses: number = 6;
  bonusReload: number = 6;

  showBonusAddress: boolean = true;

  privacyDisclaimerAgbInOne: boolean = false;

  showSEPABox: boolean = false;

  hasError = false;

  showBackToOverviewButton: boolean;
  showWarningForOrderWithoutAddress: boolean = false;
  clientWithoutAddressActivated: boolean = false;

  variantCodeDescriptions: Map<string, string> = new Map();
  askForEditionId: boolean = false;
  proposedInvoiceEmail: string = '';

  isUserLoggedIn: boolean;

  firstTry: boolean = true;
  agbChecked: boolean = false;

  currentProductAlreadyOrdered: boolean = false; //Bezieht der Nutzer das Produkt schon?

  protected readonly document = typeof document === 'object' ? document : null; // doc n.a. in SSR

  private static lastEmailInput = '';
  private registerPasswordVisibleConf = false;
  public registerPasswordVisible = false;
  private passwordComplexity = null;
  private passwordInputValidators: ValidatorFn[] = [Validators.required];

  private readonly OFFER_ID_KEY = 'OfferId: ';
  private readonly SSO_ID_KEY = ', User-SSO-Id: ';
  private readonly WEBABO_TRANSACTION_ID_KEY = ', Webabo-Transaction-Id: ';

  // validators.email allows @hup instead of @hup.de which should be not correct - use pattern validator instead
  private emailPattern = '^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)|.(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$';

  constructor(
    private formBuilder: FormBuilder,
    private baseDataService: BaseDataService,
    private loginService: LoginService,
    private offerService: OfferService,
    private hupSubscriptionsService: HupSubscriptionsService,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    public translationService: TranslationService,
    public dialog: MatDialog,
    private configService: ConfigService,
    private snackBar: SnackbarService,
    public vHostService: VHostService,
    private navigationService: NavigationService,
    private moveService: MoveService,
    private paymentTransactionService: PaymentProviderService,
    private datePipe: DatePipe,
    private decimalPipe: DecimalPipe,
    private houseNoPipe: HouseNoPipe,
    private bankAccountPipe: BankAccountPipe,
    private orderTrackingService: OrderTrackingService,
    private sanitizer: DomSanitizer,
    private imageHandler: ImageHandler,
    protected imageService: ImageService,
    private paymentService: PaymentService,
    @Inject(PLATFORM_ID) private platformId,
    private dateAdapter: DateAdapter<Date>,
    private scriptLoader: ScriptLoaderService,
  ) {
    this.dateAdapter.getFirstDayOfWeek = () => 1;
    this.isLoadingView = true;
    this.handleBaseData();
    this.handleConfigs();
  }

  private handleBaseData() {
    this.allPaymentFrequencies = this.baseDataService.getBaseData('invoicemethods');
    this.allFormsOfPayment = this.baseDataService.getBaseData('paymentmethods');
    this.salutations = this.baseDataService.getBaseData('addresscodes');
    this.clientTypes = this.baseDataService.getBaseData('clienttypes');
  }

  private handleConfigs() {
    this.configService.loadConfig('offer.maxBonusCount').subscribe(config => {
      if (config && config.value) {
        this.maxBonuses = Number(config.value);
        this.bonusReload = this.maxBonuses;
      }
    });

    this.configService.loadConfig('offer.askForBirthday').subscribe(config => {
      if (config && config.value) {
        this.askForBirthday = (config.value === 'true' || config.value === '1');
        this.askForBirthdayConst = this.askForBirthday;
      }
    });
    this.configService.loadConfig('requiredFields.addr.birthday').subscribe(config => {
      if (config && config.value) {
        this.isBirthdayRequired = (config.value === 'true' || config.value === '1');
        this.isBirthdayRequiredConst = this.isBirthdayRequired;
      }
    });

    this.configService.loadConfig('offer.askForPhone').subscribe(config => {
      if (config && config.value) {
        this.askForPhone = (config.value === 'true' || config.value === '1');
      }
    });

    this.configService.loadConfig('requiredFields.addr.phone').subscribe(config => {
      if (config && config.value) {
        this.isPhoneRequired = (config.value === 'true' || config.value === '1');
      }
    });

    this.configService.loadConfig('order.showSEPABox').subscribe(config => {
      if (config && config.value) {
        this.showSEPABox = (config.value === 'true' || config.value === '1');
      }
    });

    this.configService.loadConfig('offer.hideLoginWhileOffer').subscribe(config => {
      if (config && config.value) {
        this.hideLoginBox = (config.value === '1');
      }
    });

    this.configService.loadConfig('offer.onlyOneAddress').subscribe(config => {
      if (config && config.value) {
        this.onlyOneAddress = (config.value === '1');
      }
    });

    this.configService.loadConfig('show.backToOverView.button').subscribe(config => {
      if (config && config.value) {
        this.showBackToOverviewButton = (config.value === '1');
      }
    });

    this.configService.loadConfig('offer.showBonusAddress').subscribe(config => {
      if (config && config.value) {
        this.showBonusAddress = (config.value === 'true' || config.value === '1');
      }
    });

    this.configService.loadConfig('offer.register.showPassword').subscribe(config => {
      if (config && config.value) {
        this.registerPasswordVisibleConf = (config.value === '1');
      }
    });

    this.configService.loadConfig('offer.askForEditionId').subscribe(config => {
      if (config && config.value) {
        this.askForEditionId = (config.value === '1');
      }
    });
  }

  stepperSelectionChanged(event: StepperSelectionEvent) {
    // Wenn wir im Stepper zurück gehen, muss der Preis gelöscht werden..
    if (event.previouslySelectedIndex > event.selectedIndex) {
      this.offerPrice = null;
      this.agbChecked = false;
    }
  }

  ngAfterContentChecked(): void {

  }

  ngAfterContentInit(): void {

  }

  onResize(): void {
    this.calculateWidth();
  }

  ngAfterViewChecked(): void {
    this.calculateWidth();
  }

  calculateWidth(): void {
    const width = this.offerContainer?.nativeElement.offsetWidth;
    if (width) {
      this.colAmount = (width >= 768) ? 3 : 2;
      this.stepperOrientation = width <= 700 ? 'vertical' : 'horizontal';
      this.leftSide = width <= 850 ? 100 : 66;
      this.rightSide = width <= 850 ? 100 : 33;
    }
  }

  ngOnInit(): void {
    this.countries = this.baseDataService.getBaseData('countrycodes');
    this.showWarningForOrderWithoutAddress = this.configService.getConfig('subscription.client-without-address.show-warning').value === '1';
    this.clientWithoutAddressActivated = this.configService.getConfig('client.personWithoutAddressAllowed').value === '1';
    this.askForPaymentAccountHolder = this.configService.getConfig('askForPaymentAccountHolder').value === '1';
    this.privacyDisclaimerAgbInOne = this.configService.getConfig('offer.privacyDisclaimerAgbInOneField')?.value === '1';

    this.buildBonusForm();
    this.buildAddressForm();
    this.buildRegisterForm();
    this.buildPaymentForm();

    this.setValidationChangeListener();
    this.setAsyncValidators();

    this.route.queryParamMap.subscribe((queryParams) => {
      this.redirectUrl = queryParams.get('redirect_URL');
    });

    this.route.queryParamMap.subscribe((queryParams) => {
      this.startDateUrl = queryParams.get('startDate');
      if (this.startDateUrl) {
        this.minDate = new Date(this.startDateUrl);
      }
    });

    this.route.queryParamMap.subscribe((queryParams) => {
      this.configService.loadConfig('offer.savedQueryParams').subscribe(paramsToSave => {
        paramsToSave?.value?.split(',').forEach(param => {
          if (queryParams.has(param)) {
            this.urlParams.set(param, queryParams.get(param));
          }
        });
      });
    });

    this.setPasswordValidators();

    //*
    this.route.paramMap.subscribe((params) => {
      const offerId = params.get('offerId');
      if (offerId && Number.isInteger(+offerId)) {
        this.offerService.getOfferDetail(+offerId).subscribe(offer => {
          this.handleOffer(offer);
          this.evaluatePhoneAndBirthdayFields(offer);
          this.checkIfCurrentProductAlreadyOrdered(new Date()); //Zuerst prüfen wir, ob der Nutzer ein laufendes oder ein zukünftiges Abo für dieses Objekt hat (heute als Referenzdatum)
        });
      }
    });

    this.paymentFormGroup.get('startdate').valueChanges.subscribe({
      next: (_date) => {
        if (!_date) {
          return; // valueChanges feuert auch mit null (Initialwert/Reset)
        }
        // Der native Date-Adapter (DateAdapter<Date>) liefert bereits ein Date-Objekt, kein Moment
        const date = _date instanceof Date ? _date : new Date(_date);
        this.checkIfCurrentProductAlreadyOrdered(date); //Jedes Mal, wenn sich das Startdatum ändert, prüfen wir, ob der Nutzer ein laufendes oder ein zukünftiges Abo für dieses Objekt hat (Startdatum als Referenzdatum)
      },
    });
  }

  private checkIfCurrentProductAlreadyOrdered(referenceDate: Date) {
    const startDate = new Date(referenceDate.getFullYear(), referenceDate.getMonth(), referenceDate.getDate()).toISOString().split('T')[0];
    if (this.userData?.userBackendId && this.offer?.product.productCode) {
      this.hupSubscriptionsService.checkIfCurrentProductAlreadyOrdered(this.userData.userBackendId, this.offer.product.productCode, startDate).subscribe({
        next: orderedProduct => {
          this.currentProductAlreadyOrdered = orderedProduct.exists;
        },
        complete: () => {
          console.log('Finished checking if current product is already ordered.');
        },
        error: error => {
          catchError(error);
        }
      });
    }
  }

  isDigitalOffer(): boolean {
    return isDigital(this.offer?.offerType);
  }

  handleOffer(offer: Offer): void {
    if (offer) {
      this.offer = offer;
      // Bei ePaper-Angeboten ist die Verzichtserklärung auf das Widerrufsrecht verpflichtend
      const epaperRevocationWaiverControl = this.paymentFormGroup.get('epaperRevocationWaiver');
      if (isDigital(offer.offerType)) {
        epaperRevocationWaiverControl?.setValidators(Validators.required);
      } else {
        epaperRevocationWaiverControl?.clearValidators();
      }
      epaperRevocationWaiverControl?.updateValueAndValidity();
      this.formsOfPayment = [];

      offer.offerPaymentOfferType?.forEach(formOfPayment => {
        const foundFormOfPayment = this.allFormsOfPayment.find(searchFormOfPayment => searchFormOfPayment.key === formOfPayment.paymentMethod);
        if (foundFormOfPayment && foundFormOfPayment.useInFE && formOfPayment.paymentFrequencyList?.length > 0) {
          this.imageService.getImagePaymentType(formOfPayment.paymentMethod).subscribe(image => {
            if(image && image.type){
              formOfPayment.image = this.imageHandler.addAltText(image, formOfPayment.description ?? this.translationService.getTranslation('paymentMethod.image.altText.default'));
            }
          });
          formOfPayment.description = foundFormOfPayment.description;
          //TODO wieder ausbauen wenn die richtige Lösung da ist!
          const newDescription = this.translationService.getTranslation('paymentcode.' + foundFormOfPayment.key);
          if (newDescription && newDescription !== '') {
            formOfPayment.description = newDescription;
          }
          // der Invoice-Typ muss leider separat ermittelt werden
          this.paymentService.getPaymentMethodByCode(formOfPayment?.paymentMethod).subscribe(paymentMethod => {
            formOfPayment.invoiceType = paymentMethod.invoiceType;
          });
          this.formsOfPayment.push(formOfPayment);
        }
      });

      this.bonusSelection = false;
      if (offer.bonusList) {
        this.bonuses = [...offer.bonusList];
        if (this.bonuses.length > 0) {
          this.bonusSelection = true;
        }
        this.bonuses.forEach((bonus: Bonus) => {
          this.offerService.getArticleDescriptionFromId(bonus.articleCode).subscribe(articleDescription => {
            bonus.descriptionFromDocument = articleDescription.articleDescription;
          });
        });
        // falls nur 1 Bonus vorhanden ist, soll dieser automatisch vorgewählt werden.
        if(this.bonuses.length == 1) {
          this.onSelectBonus(this.bonuses[0], null);
        }
      }
      if(!this.bonusSelection) {
        this.setValidatorsAtIBAN(false, true);
      }

      if (offer.requiredAdditionalData) {
        offer.requiredAdditionalData.forEach(
          extendedData => {
            extendedData.dataSets.forEach(
              dataSet => {
                const control = new FormControl(dataSet.value);
                dataSet.itemkey = extendedData.itemkey;
                (this.paymentFormGroup.get('extendedData') as FormArray).push(control);
                this.additionalData.push(dataSet);
              }
            );
          }
        );
      }

      this.authSub = this.loginService.getAuthData().subscribe((authData) => {
        this.isAuthenticated = !!authData && (authData.token !== null);
        if (this.isAuthenticated) {
          this.loginService.getUserData().subscribe(userDataSso => {
            // P5W-4088: Userdaten auch dann übernehmen, wenn noch nicht im P7 gespeichert
            if (!userDataSso.userBackendId) {
              this.handleUserData(userDataSso);
            } else {
              this.moveService.getUser().subscribe({
                next: user => {
                  if (user) {
                    if (userDataSso.emailList.length > 0) {
                      user.emailList = userDataSso.emailList;
                    }
                    this.handleUserData(user);
                  }
                },
                error: () => {
                  userDataSso.person = null;
                  userDataSso.address = null;
                  userDataSso.mobileList = [];
                  userDataSso.phoneList = [];

                  this.handleUserData(userDataSso);
                }
              });
            }
          });
        }
      });

      this.hupSubscriptionsService.getNextDeliveryDate(offer.product.productCode, offer.product.variantCodeList[0]).subscribe(changeDate => {
        if(isDigital(offer.offerType)) { changeDate = new Date(); }
        if(!isDigital(offer.offerType)) {
          const date = new Date();
          const weekday = date.getDay();

          this.configService.loadConfig('order.delayToStart.' + weekday).subscribe(c => {
            if (c.value != null) {
              date.setDate(date.getDate() + parseInt(c.value));

              if (date.getTime() > changeDate.getTime()) {
                changeDate = date;
              }
            }
            const now = new Date();
            const tempDate = now.getTime() <= changeDate.getTime() ? changeDate : now;
            this.minDate = tempDate > this.minDate ? tempDate : this.minDate;
          });
        }

      });

      this.configService.loadConfig('order.maxDelayToStart').subscribe(c => {
        if (c.value != null && Number(c.value) > 0) {
          this.maxDate = new Date();
          this.maxDate.setDate(this.minDate.getDate() + Number(c.value));
        }
      });
      this.orderTrackingService.pushEvent(GtmEnum.BEGIN_CHECKOUT, offer);

      if (offer?.product?.variantCodeList.length > 0) {
        const variants = localStorage.getItem('variants_' + offer?.product?.productCode);
        if (variants && variants.length > 0) {
          // Varianten aus dem Local Storage laden, falls mit EditionResolverService geladen
          const variantArray = JSON.parse(variants);
          variantArray.forEach(_vc => {
            this.variantCodeDescriptions.set(_vc.variantCode, _vc.variantName);
          });
        } else {
          //Wenn nichts im Local Storage ist, dann selber laden
          this.offer?.product?.variantCodeList.forEach( variantCode => {
            this.baseDataService.getVariantCode(variantCode).subscribe(baseData => {
              this.variantCodeDescriptions.set(baseData.key, baseData.description);
            });
          });
        }
      }

      this.paymentFormGroup.get('editionId').patchValue(this.offer?.product?.variantCodeList[0]);
    } else {
      this.offerFound = false;
    }
  }

  handleUserData(userData: UserData): void {
    this.isLoadingUserData = false;

    this.userData = userData;

    this.proposedInvoiceEmail = this.userData.emailList?.at(0) ?? '';
    this.paymentFormGroup.get('invoiceEmail').patchValue(this.proposedInvoiceEmail);

    this.isUserLoggedIn = this.userData && this.userData?.userBackendId > 0;
    if (this.userData?.person?.initials) {
      this.userData.person.initials = this.userData.person.initials.split('.').join('');
    }
    let addressCode = this.userData.person?.addressCode;
    if( this.userData?.person?.salutation && !this.userData?.person.addressCode ) {
      this.clientTypes?.forEach(ct => {
        if(ct.key === this.userData.person.salutation) {
          addressCode = ct.defaultAddressCodeId;
        }
      });
    }
    let country = null;
    if (!!this.userData?.address) {
      this.countries?.forEach(_country => {
      if( _country.key === this.userData.address?.country.toUpperCase()) {
          country = _country;
        }
      });
    }

    if (this.offer?.requiredAddresses?.deliveryAddressRequired || this.isUserLoggedIn) {
      // // Formular vorbefüllen
      this.addressFormGroup.get('deliveryAddress.person.firstName').patchValue(this.userData.person?.firstname ?? '');
      this.addressFormGroup.get('deliveryAddress.person.lastName').patchValue(this.userData.person?.lastname ?? '');
      this.addressFormGroup.get('deliveryAddress.userData.email').patchValue(this.userData.emailList[0] ?? '');
      this.addressFormGroup.get('deliveryAddress.person.title').patchValue(this.userData.person?.title ?? '');
      this.addressFormGroup.get('deliveryAddress.person.salutation').patchValue(addressCode ?? '');
      this.addressFormGroup.get('deliveryAddress.person.initials').patchValue(this.userData.person?.initials ?? '');
      this.addressFormGroup.get('deliveryAddress.userData.birthDay').patchValue(this.userData?.birthday ?? '');
      // analog zum Geburtstag: eine bereits bekannte Nummer darf nicht erneut abgefragt werden
      this.addressFormGroup.get('deliveryAddress.userData.phone').patchValue(this.getPhoneFromUserData());

      //
      // // Formular vorbefüllen - debug, faul und so
      this.addressFormGroup.get('deliveryAddress.address.zipcode').patchValue(this.userData.address?.zipcode ?? '');
      if( this.userData.address?.country) {
        this.addressFormGroup.get('deliveryAddress.address.country').patchValue(country, {emitEvent: true});
      }
      this.addressFormGroup.get('deliveryAddress.address.city').patchValue(this.userData.address?.city ?? '');
      this.addressFormGroup.get('deliveryAddress.address.street').patchValue(this.userData.address?.street ?? '');
      // this.secondFormGroup.get('deliveryAddress.address.district').patchValue(userData.address?.district ?? '');
      let houseNoParts = userData.address?.houseno.split('#');
      if( '01' === houseNoParts?.shift() ) {
        this.addressFormGroup.get('deliveryAddress.address.houseNo').patchValue(houseNoParts[0] ?? '');
        this.addressFormGroup.get('deliveryAddress.address.stock').patchValue(houseNoParts[1] ?? '');
        this.addressFormGroup.get('deliveryAddress.address.stiege').patchValue(houseNoParts[2] ?? '');
        this.addressFormGroup.get('deliveryAddress.address.tuer').patchValue(houseNoParts[3] ?? '');
      } else if (!!houseNoParts) {
        this.addressFormGroup.get('deliveryAddress.address.houseNo').patchValue(houseNoParts[0] ?? '');
      }
      this.setValidatorsAtForm('deliveryAddress', true);
    }
    if (this.offer?.requiredAddresses?.billingAddressRequired && !this.offer?.requiredAddresses?.deliveryAddressRequired) {
      // // Formular vorbefüllen
      this.addressFormGroup.get('billingAddress.person.firstName').patchValue(this.userData.person?.firstname ?? '');
      this.addressFormGroup.get('billingAddress.person.lastName').patchValue(this.userData.person?.lastname ?? '');
      this.addressFormGroup.get('billingAddress.userData.email').patchValue(this.userData.emailList[0] ?? '');
      this.addressFormGroup.get('billingAddress.person.title').patchValue(this.userData.person?.title ?? '');
      this.addressFormGroup.get('billingAddress.person.salutation').patchValue(addressCode ?? '');
      this.addressFormGroup.get('billingAddress.person.initials').patchValue(this.userData.person?.initials ?? '');
      //
      // // Formular vorbefüllen - debug, faul und so
      this.addressFormGroup.get('billingAddress.address.zipcode').patchValue(this.userData.address?.zipcode ?? '');
      if (this.userData.address?.country) {
        this.addressFormGroup.get('billingAddress.address.country').patchValue(country);
      }
      this.addressFormGroup.get('billingAddress.address.city').patchValue(this.userData.address?.city ?? '');
      this.addressFormGroup.get('billingAddress.address.street').patchValue(this.userData.address?.street ?? '');
      // this.secondFormGroup.get('deliveryAddress.address.district').patchValue(userData.address?.district ?? '');
      let houseNoParts = userData.address?.houseno.split('#');
      if (!!houseNoParts) {
        if ('01' === houseNoParts?.shift()) {
          this.addressFormGroup.get('billingAddress.address.houseNo').patchValue(houseNoParts[0] ?? '');
          this.addressFormGroup.get('billingAddress.address.stock').patchValue(houseNoParts[1] ?? '');
          this.addressFormGroup.get('billingAddress.address.stiege').patchValue(houseNoParts[2] ?? '');
          this.addressFormGroup.get('billingAddress.address.tuer').patchValue(houseNoParts[3] ?? '');
        } else {
          this.addressFormGroup.get('billingAddress.address.houseNo').patchValue(houseNoParts[0] ?? '');
        }
      }
    } else {
      this.setValidatorsAtForm('billingAddress', false);
    }
  }

  setAsyncValidators(): void {
    this.paymentFormGroup.get('iban').setAsyncValidators(CustomValidators.validateIBAN(
      this.http,
      this.translationService,
      this.paymentFormGroup.get('bic')
    ));
    this.paymentFormGroup.get('ibanBonus').setAsyncValidators(CustomValidators.validateIBAN(
      this.http,
      this.translationService,
      this.paymentFormGroup.get('bicBonus')
    ));
    this.addressFormGroup.get('email').setAsyncValidators(CustomValidators.checkEmailAddress(
      this.http,
      this.translationService,
    ));
  }

  setValidationChangeListener(): void {
    this.addressFormGroup.get('billingAddress.showAddress').valueChanges.subscribe(value => {
      this.setValidatorsAtForm('billingAddress', value);
    });

    this.addressFormGroup.get('bonusAddress.showAddress').valueChanges.subscribe(value => {
      this.setValidatorsAtForm('bonusAddress', value);
    });

    this.paymentFormGroup.get('formOfPayment').valueChanges.subscribe(value => {
      this.handleFormOfPaymentChange(value);
    });

    this.paymentFormGroup.get('paymentFrequency').valueChanges.subscribe(value => {
      this.selectedPaymentFrequency = value;
    });

    this.paymentFormGroup.get('startdate').valueChanges.subscribe(value => {
      this.selectedStartDate = value;
    });

    this.loginFormGroup.get('email').valueChanges.subscribe(value => {
      this.addressFormGroup.get('deliveryAddress.userData.email').patchValue(value);
      this.addressFormGroup.get('billingAddress.userData.email').patchValue(value);
      this.addressFormGroup.get('bonusAddress.userData.email').patchValue(value);
      if(value?.length >= 0) {
        this.proposedInvoiceEmail = value;
      }
    });
    this.addressFormGroup.get('email').valueChanges.subscribe(value => {
      if((this.proposedInvoiceEmail?.length == 0 || value.toString().startsWith(this.proposedInvoiceEmail)) && value?.length >= 0) {
        this.proposedInvoiceEmail = value;
      }
    });
  }

  private handleFormOfPaymentChange(value) {
    this.paymentFrequencies = [];
    const findFormOfPayment = this.formsOfPayment?.find(formOfPayment => formOfPayment.paymentMethod === value.paymentMethod);
    findFormOfPayment?.paymentFrequencyList?.forEach(searchFrequency => {
      const foundFrequency = this.allPaymentFrequencies.find(frequency => frequency.key === searchFrequency);
      if (foundFrequency) {
        let needInvoiceEmail = findFormOfPayment.invoiceType === 'EMAILDELIVERY';
        this.setValidatorsAtIBAN(findFormOfPayment.paymentType === 'DIRECTDEBITIBAN', false);
        this.setValidatorsAtInvoiceEmail(needInvoiceEmail);
        if(needInvoiceEmail) {
          this.paymentFormGroup.get('invoiceEmail').patchValue(this.proposedInvoiceEmail);
        }
        this.paymentFrequencies.push(foundFrequency);
      }
    });
    this.selectedFormOfPayment = value;
    if (this.paymentFrequencies.length === 1) {
      this.paymentFormGroup.get('paymentFrequency').setValue(this.paymentFrequencies[0]);
    }
  }

  setValidatorsAtIBAN(value: boolean, forMoneyBonus: boolean) {
    let ibanField = 'iban';
    let bicField = 'bic';
    let sepaOptIn= 'sepaOptIn';
    let accountHolder = 'accountHolder';

    if(forMoneyBonus) {
      const bonus = 'Bonus';
      ibanField = ibanField.concat(bonus);
      bicField = bicField.concat(bonus);
      accountHolder = accountHolder.concat(bonus);
    }
    if (value === true) {
      this.paymentFormGroup.get(ibanField).setValidators(Validators.required);
      this.paymentFormGroup.get(ibanField).updateValueAndValidity();
      this.paymentFormGroup.get(bicField).setValidators(Validators.required);

      if (this.askForPaymentAccountHolder) {
        this.paymentFormGroup.get(accountHolder).setValidators(Validators.required);
        this.paymentFormGroup.get(accountHolder).updateValueAndValidity();
      }
      this.setAsyncValidators();
      if(!forMoneyBonus) {
        // sepaOptIn gehört zur Zahlart (SEPA-Lastschrift), nicht zur Prämien-Bankverbindung
        this.paymentFormGroup.get(sepaOptIn).enable();

        if( this.showSEPABox) {
          this.paymentFormGroup.get(sepaOptIn).setValidators(Validators.required);
          this.paymentFormGroup.get(sepaOptIn).updateValueAndValidity();
        }
        this.needIbanBic = true;
      }
    } else {
      this.paymentFormGroup.get(ibanField).clearValidators();
      this.paymentFormGroup.get(ibanField).clearAsyncValidators();
      this.paymentFormGroup.get(bicField).clearValidators();
      this.paymentFormGroup.get(accountHolder).clearValidators();

      this.paymentFormGroup.get(ibanField).reset();
      this.paymentFormGroup.get(accountHolder).reset();

      if(!forMoneyBonus) {
        this.paymentFormGroup.get(sepaOptIn).clearValidators();
        this.paymentFormGroup.get(sepaOptIn).disable();
        this.needIbanBic = false;
      }
    }
  }

  setValidatorsAtInvoiceEmail(value: boolean) {
    if (value === true) {
      this.paymentFormGroup.get('invoiceEmail').setValidators([Validators.required, Validators.pattern(this.emailPattern)]);
      this.paymentFormGroup.get('invoiceEmail').updateValueAndValidity();
      this.needInvoiceMailAddress = true;
    } else {
      this.paymentFormGroup.get('invoiceEmail').clearValidators();
      this.paymentFormGroup.get('invoiceEmail').reset();
      this.needInvoiceMailAddress = false;
    }
  }

  setValidatorsAtForm(addressName: string, value: boolean) {
    if (value === true) {
      this.addressFormGroup.get(addressName + '.person.salutation').setValidators(Validators.required);
      this.addressFormGroup.get(addressName + '.person.firstName').setValidators(Validators.required);
      this.addressFormGroup.get(addressName + '.person.lastName').setValidators(Validators.required);
      this.addressFormGroup.get(addressName + '.address.country').setValidators(Validators.required);
      this.addressFormGroup.get(addressName + '.address.zipcode').setValidators(Validators.required);
      this.addressFormGroup.get(addressName + '.address.city').setValidators(Validators.required);
      this.addressFormGroup.get(addressName + '.address.street').setValidators(Validators.required);
      this.addressFormGroup.get(addressName + '.address.houseNo').setValidators(Validators.required);
    } else {
      this.addressFormGroup.get(addressName + '.person.salutation').clearValidators();
      this.addressFormGroup.get(addressName + '.person.firstName').clearValidators();
      this.addressFormGroup.get(addressName + '.person.lastName').clearValidators();
      this.addressFormGroup.get(addressName + '.address.country').clearValidators();
      this.addressFormGroup.get(addressName + '.address.zipcode').clearValidators();
      this.addressFormGroup.get(addressName + '.address.city').clearValidators();
      this.addressFormGroup.get(addressName + '.address.street').clearValidators();
      this.addressFormGroup.get(addressName + '.address.houseNo').clearValidators();

      this.addressFormGroup.get(addressName + '.person.salutation').updateValueAndValidity();
      this.addressFormGroup.get(addressName + '.person.firstName').updateValueAndValidity();
      this.addressFormGroup.get(addressName + '.person.lastName').updateValueAndValidity();
      this.addressFormGroup.get(addressName + '.address.country').updateValueAndValidity();
      this.addressFormGroup.get(addressName + '.address.zipcode').updateValueAndValidity();
      this.addressFormGroup.get(addressName + '.address.city').updateValueAndValidity();
      this.addressFormGroup.get(addressName + '.address.street').updateValueAndValidity();
      this.addressFormGroup.get(addressName + '.address.houseNo').updateValueAndValidity();
    }
  }

  setPasswordValidators(): void {
    // ToDo: translations
    this.loginService.getPasswordComplexityInfo().subscribe(data => {
      if (data) {
        this.passwordComplexity = data;
        if (parseInt(data.minLength)) {
          this.passwordInputValidators.push((c: AbstractControl) => {
            const missing = Math.max(0, parseInt(data.minLength) - c.value.length);
            return missing ? {minLength: missing + ' Zeichen'} : null;
          });
        }
        if (parseInt(data.lowerChars)) {
          this.passwordInputValidators.push((c: AbstractControl) => {
            const missing = Math.max(0, parseInt(data.lowerChars) - c.value.replace(/[^a-zäöüáéíóúýàèìòùâêîôûßčěňřšůž]/g, '').length);
            return missing ? {lowerChars: missing + ' Kleinbuchstabe' + (missing == 1 ? '' : 'n')} : null;
          });
        }
        if (parseInt(data.upperChars)) {
          this.passwordInputValidators.push((c: AbstractControl) => {
            const missing = Math.max(0, parseInt(data.upperChars) - c.value.replace(/[^A-ZÄÖÜÁÉÍÓÚÝÀÈÌÒÙÂÊÎÔÛĎČĚŇŘŠŤŮŽ]/g, '').length);
            return missing ? {upperChars: missing + ' Großbuchstabe' + (missing == 1 ? '' : 'n')} : null;
          });
        }
        if (parseInt(data.digits)) {
          this.passwordInputValidators.push((c: AbstractControl) => {
            const missing = Math.max(0, parseInt(data.digits) - c.value.replace(/[^0-9]/g, '').length);
            return missing ? {digits: missing + ' Ziffer' + (missing == 1 ? '' : 'n')} : null;
          });
        }
        if (parseInt(data.specialChars)) {
          this.passwordInputValidators.push((c: AbstractControl) => {
            const missing = Math.max(0, parseInt(data.specialChars) - c.value.replace(/[0-9a-zäöüáéíóúýàèìòùâêîôûßčěňřšůžA-ZÄÖÜÁÉÍÓÚÝÀÈÌÒÙÂÊÎÔÛĎČĚŇŘŠŤŮŽ]/g, '').length);
            return missing ? {specialChars: missing + ' Sonderzeichen'} : null;
          });
        }
      }
    });
  }

  buildBonusForm(): void {
    this.bonusFormGroup = this.formBuilder.group({
      bonus: new FormArray([], Validators.required)
    });
  }

  buildAddressForm(): void {
    this.addressFormGroup = this.formBuilder.group({
      deliveryAddress: this.formBuilder.group({
        userData: this.formBuilder.group( {
          birthDay: [''],
          phone:[''],
          email: ['']
        }),
        showAddress: [''],
        address: this.formBuilder.group({
          country: [''],
          zipcode: [''],
          city: [''],
          street: [''],
          houseNo: [''],
          extraLine: [''],
          houseNoExt: [''],
          stiege: [''],
          stock: [''],
          tuer: [''],
          district: ['']
        }),
        person: this.formBuilder.group({
          title: [''],
          salutation: [''],
          firstName: [''],
          lastName: [''],
          initials: [''],
          middlename: ['']
        })
      }),
      billingAddress: this.formBuilder.group({
        userData: this.formBuilder.group({
          birthDay: [''],
          phone:[''],
          email: ['']
        }),
        showAddress: [''],
        address: this.formBuilder.group({
          country: [''],
          zipcode: [''],
          city: [''],
          street: [''],
          houseNo: [''],
          extraLine: [''],
          houseNoExt: [''],
          stiege: [''],
          stock: [''],
          tuer: [''],
          district: ['']
        }),
        person: this.formBuilder.group({
          title: [''],
          salutation: [''],
          firstName: [''],
          lastName: [''],
          initials: [''],
          middlename: [''],
        })
      }),
      bonusAddress: this.formBuilder.group({
        userData: this.formBuilder.group({
          birthDay: [''],
          phone:[''],
          email: [''],
        }),
        showAddress: [''],
        address: this.formBuilder.group({
          country: [''],
          zipcode: [''],
          city: [''],
          street: [''],
          houseNo: [''],
          extraLine: [''],
          houseNoExt: [''],
          stiege: [''],
          stock: [''],
          tuer: [''],
          district: ['']
        }),
        person: this.formBuilder.group({
          title: [''],
          salutation: [''],
          firstName: [''],
          lastName: [''],
          initials: [''],
          middlename: [''],
        })
      }),
      advertiserAddress: this.formBuilder.group({
          address: this.formBuilder.group({
            country: [''],
            zipcode: [''],
            city: [''],
            street: [''],
            houseNo: [''],
            extraLine: [''],
            houseNoExt: [''],
            stiege: [''],
            stock: [''],
            tuer: [''],
            district: ['']
          }),
          person: this.formBuilder.group({
            title: [''],
            salutation: [''],
            firstName: [''],
            lastName: [''],
            initials: [''],
            middlename: [''],
          })
        }
      ),
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
    });

    if (!this.hideLoginBox) {
      this.addressFormGroup.get('email').clearValidators();
    }
  }

  buildPaymentForm(): void {
    this.paymentFormGroup = this.formBuilder.group({
      formOfPayment: ['', Validators.required],
      paymentFrequency: ['', Validators.required],
      iban: [''],
      bic: [{value: this.translationService.getTranslation('filled_automatically'), disabled: true}],
      accountHolder: [''],
      ibanBonus: [''],
      bicBonus: [{value: this.translationService.getTranslation('filled_automatically'), disabled: true}],
      accountHolderBonus: [''],
      sepaOptIn: [''],
      optinFormArray: new FormArray([]),
      invoiceEmail: [''],
      extendedData: new FormArray([]),
      startdate: new FormControl<Date | null>(null, Validators.required),
      enddate: [''],
      agb: [''],
      privacy: [''],
      disclaimer: [''],
      privacyDisclaimerAgb: [''],
      epaperRevocationWaiver: [''],
      editionId: ['']
    });
  }

  buildRegisterForm(): void {
    this.loginFormGroup = this.formBuilder.group(
      {
        email: [
          OfferDetailComponent.lastEmailInput.length ? OfferDetailComponent.lastEmailInput : '', [
            Validators.required,
            Validators.pattern(this.emailPattern)
          ]],
        password: ['', []]
      },
      {
        validators: [CustomValidators.checkRegisterForm(this.registerPasswordVisibleConf)]
      }
    );
    this.loginFormGroup.get('password').disable();
  }

  get deliveryAddressGroup(): FormGroup {
    return this.addressFormGroup.get('deliveryAddress') as FormGroup;
  }

  get billingAddressGroup(): FormGroup {
    return this.addressFormGroup.get('billingAddress') as FormGroup;
  }

  get bonusAddressGroup(): FormGroup {
    return this.addressFormGroup.get('bonusAddress') as FormGroup;
  }

  get advertiserAddressGroup(): FormGroup {
    return this.addressFormGroup.get('advertiserAddress') as FormGroup;
  }

  onOptInsSelected(selectedOptIns: Map<number, boolean>) {
    this.optinResult = selectedOptIns;
  }

  onCompleteOrder(orderResult: OrderResultModel): void {
    this.creatingOrder = true;
    // Nach oben scrollen, damit man den Spinner und die Fehlermeldungen sieht!
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }
    this.showOnlinePayment = false;
    this.errorsArr = [];
    const data = this.buildDataObjectForService(false, orderResult);
    if (!data.validEmail) {
      return;
    }
    if (!this.userData || this.clientNoUrl) {
      this.hupSubscriptionsService.sendSubscriptionUnauthorized(data).subscribe({
        next: (res) => {
          this.orderTrackingService.pushEvent(GtmEnum.PURCHASED, res.body);
          this.doUpScoreTracking();
          const otlcCode = res.otlc ?? '';
          if (otlcCode.length) {
            this.loginService.loginByOtlc(otlcCode);
          }
          // Result an der Session speichern, da wir nichts nachladen können -> User ist noch nicht da ^^
          this.creatingOrder = false;
          const id: number = res.body.webId;
          /* falls direkt nach Paradise geschrieben wird, ist die backendId > 0 und die webId = 0. => Das Abo kann nicht geladen werden und die Bestellbestätigungsseite ist leer.
          Es muss also möglich sein, aus beiden Quellen das Abo zu laden */
          const backendId: string = res.body.backendId > 0 ? res.body.backendId.toString() : '-1';
          this.hupSubscriptionsService.setPriceForKey(id, this.offerPrice);
          this.navigationService.navigateTo(NavigationCommand.OFFERORDERED, [id.toString(), backendId, '0']).then((navigated) => {
            if (navigated) {
              this.snackBar.openSnackbar(this.translationService.getTranslation('saved'));
            }
          });
        },
        error: (error) => {
          // const errTestObj = {};  // Warning, wenn einkommentiert
          this.creatingOrder = false;
          console.error(error);
          //this.errorService.handleAPIError([this.firstFormGroup, this.secondFormGroup, this.thirdFormGroup, this.fourthFormGroup, this.fifthFormGroup], errTestObj, this.errorsArr, stepper);
        }
      });
    } else {
      this.hupSubscriptionsService.sendOffer(data).subscribe({
        next: (res) => {
          this.orderTrackingService.pushEvent(GtmEnum.PURCHASED, res);
          this.doUpScoreTracking();
          this.creatingOrder = false;
          const id: number = res.backendId > 0 ? res.backendId : res.webId;
          this.hupSubscriptionsService.setPriceForKey(id, this.offerPrice);
          localStorage.removeItem('variant_' + this.offer?.product?.productCode);
          this.navigationService.navigateTo(NavigationCommand.OFFERORDERED, [res.webId, res.backendId, '0']);
        },
        error: (error) => {
          this.creatingOrder = false;
          // const errTestObj = {};  // Warning, wenn einkommentiert
          console.error(error);
          // this.errorService.handleAPIError(fusingTest, error.error, this.errorsArr);
          // this.errorService.handleAPIError([this.complaintForm, this.complaintCompensationForm], error.error, this.errorsArr);
          //this.errorService.handleAPIError([this.firstFormGroup, this.secondFormGroup, this.thirdFormGroup, this.fourthFormGroup, this.fifthFormGroup], errTestObj, this.errorsArr, stepper);
        }
      });
    }
  }

  /**
   * triggert UpScore
   *
   * Wenn offer.tracking.upScore.domain nicht leer ist, wird UpScore ausgeführt.
   * Der UpScore-Parameter "object_id" wird in den Site-URL-Suchparametern unter dem (Konfig-)Key "offer.tracking.upScore.objectIdKey" gesucht.
   * Der UpScore-Parameter "url" wird in den Site-URL-Suchparametern unter dem (Konfig-)Key "offer.tracking.upScore.urlKey" gesucht.
   */
  async doUpScoreTracking(): Promise<void> {
    const urlParamMap = Object.fromEntries(new URLSearchParams(window.location.search));

    const executorFn = () => {
      // Parameter-Keys bestimmen
      let objectIdKey = this.configService.getConfig('offer.tracking.upScore.objectIdKey')?.value;
      // set Default-Values, falls leer
      objectIdKey = !!objectIdKey ? objectIdKey : 'upScoreId';
      // Parameterwert ermitteln
      let objectId = urlParamMap[objectIdKey] ?? '';

      const data = {object_id: objectId, object_type: 'article', conversion: 2};
      let p;

      if (upScoreVersion == 'v3') {
        p = {config: {domain: upScoreDomainObj.hostname, article: 'article', track_positions: true}, data: data};
      } else {
        p = {...data, ...{url: upScoreDomainObj.origin}};
      }

      console.log('%cUpScore-Parameter: ', 'color:orange;', p);

      // @ts-ignore
      upScoreVersion == 'v3' ? upScore(p) : upScore('page_view', p);
    };

    let upScoreDomain = this.configService.getConfig('offer.tracking.upScore.domain')?.value;
    let upScoreVersion = this.configService.getConfig('offer.tracking.upScore.version')?.value ?? 'v4';
    // P5W-3521: SDZC | Anbindung UpScore API für Conversion-Messung
    // mehrere Portale leiten zu einem WebAbo-Shop
    //   1) die Domain wird in diesem Fall als URL-Parameter übergeben (Param:urlParamName), oder
    //   2) ggf. in einem "Sub"-Parameter dieses Parameters (Param:urlParamName->subParamName)
    if (upScoreDomain.startsWith('Param:')) {
      let upScoreDomainConf = upScoreDomain.substring('Param:'.length).split('->');
      let upScoreDomainByParam = urlParamMap[upScoreDomainConf[0]] ?? null;
      // Falls Parameter im Parameterwert zu finden ist, ...
      if (!!upScoreDomainConf[1]) {
        // ... 1st-Level Parameter dekodieren, ...
        upScoreDomainByParam = decodeURIComponent(upScoreDomainByParam);
        // ... die URL-Parameter ermitteln, ...
        const secondLevelUrlParams = Object.fromEntries(new URLSearchParams(upScoreDomainByParam.split('?').pop()));
        // ... den eingebetteten 2nd-Level Parameter auslesen und schließlich ...
        upScoreDomainByParam = secondLevelUrlParams[upScoreDomainConf[1]] ?? null;
      }

      upScoreDomain = upScoreDomainByParam ?? null;
    }

    let upScoreDomainObj: URL;

    if (!!upScoreDomain) {
        // ... den Domain-/Hostnamen ermitteln
        try{
        // a) komplette URL gegeben
        upScoreDomainObj = new URL(upScoreDomain);
      } catch (e) {
        // b) nur Hostname vorhanden
        try {
          upScoreDomainObj = new URL('https://' + upScoreDomain);
        } catch (e) {
          // c) leider keins von beiden
          console.error('UpScore-Domain kann nicht ermittelt werden aus URL: ' + e.message);
          upScoreDomainObj = null;
        }
      }
    }

    if (!!upScoreDomainObj) {
      // nur sld + tld verwenden
      const needProtocol = !upScoreDomainObj.origin.startsWith('http');
      const protocol = needProtocol ? upScoreDomainObj.protocol + '//' : '';
      upScoreDomainObj = new URL( protocol + upScoreDomainObj.origin.split('.').slice(-2).join('.') );

      // @ts-ignore
      if (typeof upScore === 'function') {
        executorFn();
      } else {
        const possibleUpScoreLocations = {
          v3: 'https://files.upscore.com/async/upScore.js',  // v3
          v4: 'https://files.upscore.com/site_script/' + upScoreDomainObj.hostname + '.js' // v4
        };

        const scriptUrl = possibleUpScoreLocations[upScoreVersion];

        try {
          await this.scriptLoader.loadScript(scriptUrl);
          // @ts-ignore
          if (typeof upScore === 'function') {
            executorFn();
            return;
          } else {
            console.error('UpScore-API nicht gefunden (' + scriptUrl + ')');
          }
        } catch (err) {
          console.error(err);
        }
      }
    }
  }

  getBonusControls(): AbstractControl[] {
    return (this.bonusFormGroup.get('bonus') as FormArray).controls;
  }

  /**
   * beim Auswählen einer Prämie durch den Nutzer:
   * prüft, ob der Nutzer genügend Punkte hat, um sie auszuwählen. Falls ja, wird er ausgewählt (ermöglicht mehrere Prämien)
   * falls nein: Alle Prämien werden entfernt, und die gewünschte wird ausgewählt
   * hier ist ein Sonderfall zu beachten, wenn der Nutzer eine Prämie auswählt, die schon gewählt ist, soll natürlich nichts geschehen
   * @param bonus die ausgewählte Prämie
   * @param element html element der Prämie
   */
  onSelectBonus(bonus: Bonus, element: HTMLElement): void {
    if (!bonus.bonusValue || bonus.bonusValue < 1) {
      bonus.bonusValue = 12;
    }

    let found = this.isBonusAlreadySelected(bonus);
    //falls der bonus noch nicht ausgewählt ist
    if (!found) {
      // es gibt genügend freie punkte, um den bonus auszuwählen
      if (this.freeBonusPoints >= bonus.bonusValue) {
        this.addBonus(bonus);
      }
      //es gibt nicht genügend freie bonuspunkte
      else if (this.freeBonusPoints < bonus.bonusValue) {
        this.removeAllBonuses();
        this.addBonus(bonus);

      }
    }
    if (element) {
      element.scrollIntoView({behavior: 'smooth', block: 'center', inline: 'nearest'});
    }

    this.handleBirthdayField();
  }

  /**
   * prüft, ob eine Prämie bereits ausgewählt ist
   * @param bonus
   * @private
   */
  private isBonusAlreadySelected(bonus: Bonus) {
    const control = new FormControl(bonus);
    let found = false;
    for (let data of this.getBonusControls()) {

      if (data.value == control.value) {
        found = true;
      }
    }
    return found;
  }

  /**
   * fügt eine Prämie zu den ausgewählten Prämien hinzu
   * @param bonus
   * @private
   */
  private addBonus(bonus: Bonus) {
    const control = new FormControl(bonus);
    (this.bonusFormGroup.get('bonus') as FormArray).push(control);
    this.selectedBonus.push(bonus);
    bonus.selected = true;
    this.moneyBonusSelected = bonus?.bonusType == BonusType.MONEY_BONUS;
    this.nonMoneyBonusWithClientCoPaymentSelected = bonus?.bonusType == BonusType.NON_MONEY_BONUS && bonus?.clientCoPayment > 0;
    this.setValidatorsAtIBAN(this.moneyBonusSelected || this.nonMoneyBonusWithClientCoPaymentSelected, true);
    this.calcBonusPoints();
  }

  onDeselectBonus(index: number): void {
    let bonus : Bonus = this.selectedBonus[index];
    (this.bonusFormGroup.get('bonus') as FormArray).removeAt(index);
    this.calcBonusPoints();
    this.selectedBonus.splice(index, 1);
    for (let i = 0; i < this.bonuses.length; i++) {
      if (bonus == this.bonuses[i]){
        this.bonuses[i].selected = false;
        break;
      }
    }
    this.moneyBonusSelected = false;
    this.nonMoneyBonusWithClientCoPaymentSelected = false;
    this.setValidatorsAtIBAN(false, true);

    this.handleBirthdayField();
  }

  /**
   * wählt alle boni ab
   * @private
   */
  private removeAllBonuses(){
    (this.bonusFormGroup.get('bonus') as FormArray).clear();
    this.calcBonusPoints();
    this.selectedBonus = [];
    for (let bonus of this.bonuses) {
      bonus.selected =false;
    }
    this.moneyBonusSelected = false;
    this.nonMoneyBonusWithClientCoPaymentSelected = false;
    this.setValidatorsAtIBAN(false, true);
  }

  getAdditionalDataControls(): AbstractControl[] {
    return (this.paymentFormGroup.get('extendedData') as FormArray).controls;
  }

  onSelectAddresses() {

    const data = this.buildDataObjectForService(true);
    const billingAddress = data.billingAddress;
    if (billingAddress) {
      this.selectedBillingAddress = billingAddress;
      this.selectedBillingAddress.required = this.offer.requiredAddresses.billingAddressRequired;
    }
    const deliveryAddress = data.deliveryAddress;
    if (deliveryAddress) {
      this.selectedDeliveryAddress = deliveryAddress;
    }
    if (!!data.selectedGiftList) {
      this.selectedBonusAddress = {
        person: data.selectedGiftList[0].person,
        address: data.selectedGiftList[0].address
      };
      this.selectedBonusAddress.required = this.bonusSelection;
    }
    this.orderTrackingService.pushEvent(GtmEnum.ADDED_ADDRESSES, data );
  }

  setUniquePaymentInfos(): void {
      this.paymentFormGroup.get('formOfPayment').setValue(this.formsOfPayment[0]);
      this.handleFormOfPaymentChange(this.formsOfPayment[0]);
    }

  onSelectFormOfPayment(formOfPayment) {
    this.selectedFormOfPayment = formOfPayment;
    this.showOnlinePayment = formOfPayment?.paymentType == 'ONLINEPAYMENT';
    if (formOfPayment) {
      this.paymentFormGroup.get('formOfPayment').patchValue(formOfPayment);
    } else {
      this.paymentFormGroup.get('formOfPayment').patchValue(null);
    }
  }

  calcBonusPoints(): void {

    let usedPoints = 0;

    (this.bonusFormGroup.get('bonus') as FormArray).controls.forEach((bonus) => {
      usedPoints += bonus.value.bonusValue;
    });

    this.usedPoints = usedPoints;
    this.freeBonusPoints = this.maxPoints - usedPoints;

  }

  onShowDetails(bonus: Bonus): void {
    this.dialog.open(BonusDetailComponent, {
      data: {bonus, showBonusPoints: false}
    });
  }

  calcPriceOfSubscription(): void {
    const data = this.buildDataObjectForService(false);
    this.orderTrackingService.pushEvent(GtmEnum.ADDED_PAYMENT, data);
    if(!data.validEmail) {
      return;
    }
    if (this.offer.priceCalculationActivated) {
        this.hasError = false;
        this.calculatingPrice = true;
        this.hupSubscriptionsService.getPriceForSubscription(data).subscribe({
          next: (prices) => {
            const data = this.buildDataObjectForService(false);
            this.orderTrackingService.pushEvent(GtmEnum.CALCULATED_PRICE, prices);
            this.calculatingPrice = false;
            const period = {
              validFrom: data.validDate.validFrom,
              validUntil: null
            };
            const calculatedPrices = [];
            prices.forEach(price => {
              if (price.trial) {
                const trialPrice = new OfferPrice(data.quantity, period, data.currency, price.price, null, true, price.porto, price.portoDescription);
                calculatedPrices.push(trialPrice);
              } else {
                if ( price.previewPrice) {
                  const resultPrice: OfferPrice = new OfferPrice(data.quantity, period, price.previewPrice.currency, price.previewPrice.price, this.offer.priceCalculationSummary, false, price.porto, price.portoDescription);
                  calculatedPrices.push(resultPrice);
                } else if ((price.price > 0) || calculatedPrices.length == 0){
                  const resultPrice: OfferPrice = new OfferPrice(data.quantity, period, price.currency, price.price, this.offer.priceCalculationSummary, false, price.porto, price.portoDescription);
                  calculatedPrices.push(resultPrice);
                }
              }
            });

            const displayPricesAsSum = this.configService.getConfig('order.price.combiPricesAsSum');
            if( (displayPricesAsSum?.value === '1' || displayPricesAsSum?.value === 'true') && calculatedPrices.length > 1 ) {
              let price : number = 0.0;
              calculatedPrices.forEach( pricePart => price = price + pricePart.price );
              calculatedPrices[0].price = price;
              this.offerPrice = [ calculatedPrices[0] ];
            } else {
              this.offerPrice = calculatedPrices;
            }

            const transaction = new PaymentTransactionModel();
            transaction.amount = calculatedPrices[0].price;

            //Sichern der Webabo-Transactionsdaten für die Beschreibung (Bestellübersicht) im PayPal: so können die Daten ggf der Bestellung zugeordnet werden
            const trackingTransactionId = this.orderTrackingService.getTransactionId();
            const hasSSOId = this.userData?.userSSOId > 0;
            transaction.invoiceText = this.OFFER_ID_KEY + this.offer.recno
              + (hasSSOId ? this.SSO_ID_KEY + this.userData.userSSOId : '0')
              + (trackingTransactionId ? this.WEBABO_TRANSACTION_ID_KEY + trackingTransactionId : '-');

            const paymentCode = data?.payment?.paymentType?.paymentMethod;
            const paypalPaymentCode = this.configService.getConfig('paymentprovider.paypal.paymentcode');
            const buckarooPaymentCode = this.configService.getConfig('paymentprovider.buckaroo.paymentcode');
            if (paymentCode === paypalPaymentCode?.value) {
              transaction.provider = PaymentProvider.PAYPAL;
              this.showOnlinePayment = true;
            } else if (paymentCode == buckarooPaymentCode?.value) {
              transaction.provider = PaymentProvider.BUCKAROO;
              transaction.orderObject = this.buildDataObjectForService(false);
              this.showOnlinePayment = true;
            }
            if (this.showOnlinePayment) {
              this.paymentTransactionService.setNewTransaction(transaction);
            }
          },
          error: (error) => {
            this.calculatingPrice = false;
            this.hasError = true;
            console.error(error);
          }
        });
    } else {
      this.offerPrice = [
        new OfferPrice(
          1, {validFrom: new Date(), validUntil: new Date()}, null, null,
          this.offer.priceCalculationSummary, false, null, null
        )
      ];
    }
  }

  checkBoxesChecked(): boolean {
    this.checkBoxes = true;
    const baseChecked = (this.paymentFormGroup.get('agb')?.value && this.paymentFormGroup.get('privacy')?.value && this.paymentFormGroup.get('disclaimer')?.value) ||
      this.paymentFormGroup.get('privacyDisclaimerAgb')?.value;
    return baseChecked && (!this.isDigitalOffer() || !!this.paymentFormGroup.get('epaperRevocationWaiver')?.value);
  }

  buildDataObjectForService(forView: boolean, orderResult: OrderResultModel = null): any {
    const transaction = orderResult?.paymentTransaction;
    const bonusData = JSON.parse(JSON.stringify(this.bonusFormGroup.value));
    const advertiserData = JSON.parse(JSON.stringify(this.advertiserAddressGroup.value));
    const addresses = JSON.parse(JSON.stringify(this.addressFormGroup.getRawValue()));
    const additionalDataValues = JSON.parse(JSON.stringify(this.paymentFormGroup.value));
    const paymentInfos = JSON.parse(JSON.stringify(this.paymentFormGroup.value));
    const bonusPaymentInfos = JSON.parse(JSON.stringify(this.paymentFormGroup.value));
    const dateAndAGBs = JSON.parse(JSON.stringify(this.paymentFormGroup.value));
    const register = JSON.parse(JSON.stringify(this.loginFormGroup.value));
    let billingAddress = this.buildAddressList(this.offer.requiredAddresses.billingAddressRequired, addresses.billingAddress, dateAndAGBs.startdate, null, forView);
    let bonusAddress = this.buildAddressList(this.bonusSelection, addresses.bonusAddress, dateAndAGBs.startdate, null, forView);
    let deliveryAddress = this.buildAddressList(this.offer.requiredAddresses.deliveryAddressRequired, addresses.deliveryAddress, dateAndAGBs.startdate, null, forView);

    let birthday = addresses?.deliveryAddress?.userData?.birthDay;

    if (!birthday && birthday === '') {
      birthday = addresses?.billingAddress?.userData?.birthDay;
    }
    if (!birthday && birthday === '') {
      birthday = addresses?.bonusAddress?.userData?.birthDay;
    }

    let phone = addresses?.deliveryAddress?.userData?.phone;
    if (!phone && phone === '') {
      phone = addresses?.billingAddress?.userData?.phone;
    }
    if (!phone && phone === '') {
      phone = addresses?.bonusAddress?.userData?.phone;
    }

    const payment = this.buildPaymentInfo(paymentInfos);

    if (!this.offer.requiredAddresses.deliveryAddressRequired &&
      this.offer.requiredAddresses.billingAddressRequired) {
      deliveryAddress = billingAddress;
    }

    // Abweichende Rechnungsadresse wurde ausgewählt
    if (this.addressFormGroup.get('billingAddress.showAddress').value === '' || this.addressFormGroup.get('billingAddress.showAddress').value == null) {
      if (forView) {
        billingAddress = null;
      } else if (this.offer.requiredAddresses.deliveryAddressRequired) {
        billingAddress = deliveryAddress;
      }
    } else {
      if (billingAddress) {
        billingAddress.userBackendId = 0;
      }
    }

    // Falls Rechnungsadresse abweichend & Zustelladresse nicht notwendig ist, dann ist es eine neue Adresse
    if (this.userData?.userBackendId > 0 && !this.offer.requiredAddresses.deliveryAddressRequired) {
      if (billingAddress) {
        billingAddress.userBackendId = 0;
      }
      deliveryAddress.userBackendId = 0;
    }

    if (!this.offer.requiredAddresses.deliveryAddressRequired &&
      this.offer.requiredAddresses.billingAddressRequired) {
      deliveryAddress = billingAddress;
    }

    //Dieselbe Bonus- und Lieferadresse
    if ((this.addressFormGroup.get('bonusAddress.showAddress').value === '' || this.addressFormGroup.get('bonusAddress.showAddress').value == null ) && this.bonusSelection && !forView) {
      bonusAddress = deliveryAddress;
    }

    let deliveryAddressEmail = addresses?.billingAddress?.userData?.email;
    if(deliveryAddressEmail == null || deliveryAddressEmail.trim() == ''){
      deliveryAddressEmail = addresses?.deliveryAddress?.userData?.email;
    }

    /* Falls über den Link mit QueryParams navigiert wurde, schauen wir, ob eine Referenz auf den Werber vorhanden ist:
    * https://domainname.de/offer/195?werber=79378. Der Name für das Werber-Parameter muss mit der WebDB abgestimmt werden.*/
    let advertiserId = 0;
    this.route.queryParamMap.subscribe(params => {
      const advertiserParamKey = this.translationService.getTranslation('advertiser');
      const validParam = advertiserParamKey.trim().length > 0;
      if (validParam && params.get(advertiserParamKey)) {
        advertiserId = parseInt(params.get(advertiserParamKey));
      }
    });

    // !offer.requiredAddresses.billingAddressRequired && !offer.requiredAddresses.deliveryAddressRequired
    if (!billingAddress && !deliveryAddress) {
      const defaultCountryCode = this.configService.getConfig('requiredFields.addr.defaultCountry').value;
      billingAddress = {
        person: {
          // firstname: '',
          // lastname: ''
        },
        address: {
          country: defaultCountryCode ?? 'D'
        },
        validDate: {
          validFrom: this.datePipe.transform(dateAndAGBs.startdate, 'yyyy-MM-dd')
        }
      };

      deliveryAddress = billingAddress;
    }

    let data: any = {
      offerId: this.offer?.recno,
      quantity: 1,
      billingAddress,
      deliveryAddress,
      validDate: {
        validFrom: this.datePipe.transform(dateAndAGBs.startdate, 'yyyy-MM-dd')
      },
      payment,
      userAgreement: {},
      optinList: [],
      email: deliveryAddressEmail && deliveryAddressEmail !== '' ? deliveryAddressEmail: addresses.email,
      registerPassword: register?.password ?? null,
      userBackendId: this.userData?.userBackendId ?? -1,
    };
    if (bonusData && bonusData.bonus.length > 0) {
      if(bonusData.bonus[0].bonusType === BonusType.MONEY_BONUS || this.nonMoneyBonusWithClientCoPaymentSelected) {
        if (bonusPaymentInfos.ibanBonus) {
          let objBank: any;
          objBank = {
            swiftIBAN: bonusPaymentInfos.ibanBonus,
            accountHolder: bonusPaymentInfos.accountHolderBonus?.trim()
          };
          bonusData.bonus[0].bankAccount = objBank;
        }
      }
      bonusData.bonus.forEach((bonus: Bonus & Pick<SelectedGift, 'articleDescription'>) => {
        bonus.articleDescription = bonus.name || bonus.description || bonus.descriptionFromDocument;
      });
      data.selectedGiftList = bonusData.bonus;
    }

    // todo: laut ILO muss es irgendwann keine Liste von Prämien mehr sein, sondern nur ein einzelnes Element
    if (bonusAddress) {
      for (let i = 0; i < data.selectedGiftList.length; i++) {
        data.selectedGiftList[i].person = bonusAddress?.person;
        data.selectedGiftList[i].address = bonusAddress?.address;
      }
      this.selectedBonusAddress = {
        person: data.selectedGiftList[0].person,
        address: data.selectedGiftList[0].address
      };
    }
    if (additionalDataValues.extendedData) {
      let index = 0;
      let extendedData: SubExtendedData[] = [];
      additionalDataValues.extendedData.forEach(value => {
        let currentDataSet = this.additionalData[index];
        currentDataSet.value = value;
        let found = false;
        extendedData.forEach(data => {
          if(data.itemkey == currentDataSet.itemkey) {
            data.dataSets.push(currentDataSet);
            found = true;
          }
        });
        if(!found) {
          let newData = new SubExtendedData();
          newData.itemkey = this.additionalData[index].itemkey;
          newData.dataSets.push(currentDataSet);
          extendedData.push(newData);
        }
        index++;
      });
      data.additionalData = extendedData;
    }
    if (this.redirectUrl) {
      data.redirectUrl = this.redirectUrl;
    }
    data.userAgreement.checkAGB = orderResult?.agb ?? true;
    data.userAgreement.checkPrivacy = orderResult?.privacy ?? true;
    data.userAgreement.checkWiderruf = orderResult?.disclaimer ?? true;

    this.optinResult.forEach((value: boolean, key: number) => {
      if(value) {
        data.optinList.push(key);
      }
    });

    if (birthday) {
      birthday = this.datePipe.transform(birthday, 'yyyy-MM-dd');
      data.birthday = birthday;
    }

    if (phone) {
      data.phoneCode = phone.split('/')[0];
      data.phone = phone.split('/')[1];
    }

    // transaction ans Auftragsobjekt schreiben, damit diese Daten übernommen werden in die SUB_ONLINEPAYMENT
    if (transaction) {
      data.payment.onlinePayment = {};
      data.payment.onlinePayment.transactionId = transaction.transactionId;
      data.payment.onlinePayment.transactionProvider = transaction.provider;
      data.payment.onlinePayment.amount = transaction.amount;
      data.payment.onlinePayment.transactionInfo = transaction.invoiceText;
    }
    data.additionalOfferParams = Object.fromEntries(this.urlParams);
    data.variantCode = paymentInfos?.editionId;
    data.validEmail = true;

    this.handleAdvertiser(advertiserId, advertiserData, data, forView);

    if(data.email?.length <= 0 && !forView) {
      if(!this.userData && !this.clientNoUrl) {
        this.loginFormGroup.get('email').updateValueAndValidity();
        if (this.loginFormGroup.get('email').invalid) {
          this.stepper.selectedIndex = 0;
          data.validEmail = false;
        } else {
          data.email = this.loginFormGroup.get('email').value;
        }
      } else if(this.userData?.emailList?.length > 0){
        data.email = this.userData.emailList[0];
      }
    }
    return data;
  }

  private handleAdvertiser(advertiserId: number, advertiserData: any, data: any, forView: boolean) {
    // Werber-ID aus der URL (LWS)
    if (advertiserId > 0) {
      data.advertiser = {
        person: {
          userBackendId: advertiserId
        }
      };
    }

    //"Leser werben Leser" - Angebot (FZD)
    if (advertiserData) {
      data.advertiser = {
        person: {
          firstname: advertiserData.person.firstName,
          lastname: advertiserData.person.lastName,
          title: advertiserData.person.title.key,
          salutation: advertiserData.person.salutation.key,
          initials: advertiserData.person.initials,
          middlename: advertiserData.person.middlename
        },
        address: {
          country: advertiserData.address.country.key,
          zipcode: advertiserData.address.zipcode,
          city: advertiserData.address.city,
          street: advertiserData.address.street,
          houseno: this.buildHouseNo(advertiserData, forView),
          addrExtraLine1: advertiserData.address.extraLine,
          district: advertiserData.address.district
        }
      };
    }
  }

  buildPaymentInfo(paymentInfos: any): any {
    let objBank: any;
    let payment: any = {};
    let paymentType: any;

    if (paymentInfos.iban) {
      objBank = {
        swiftIBAN: this.isString(paymentInfos.iban) ? paymentInfos.iban.trim() : paymentInfos.iban,
        accountHolder: paymentInfos.accountHolder?.trim()
      };
      payment.bank = objBank;
    }
    paymentType = {
      paymentMethod: paymentInfos.formOfPayment.paymentMethod,
      paymentFrequency: paymentInfos.paymentFrequency.key
    };
    payment.invoiceEmail = paymentInfos.invoiceEmail;
    payment.paymentType = paymentType;

    return payment;
  }

  isString(x): boolean {
    return Object.prototype.toString.call(x) === '[object String]';
  }

  buildAddressList(required: boolean, addressFormJson, validFrom: string, validUntil: string, forView: boolean): any {
    let subscriptionAddress = null;
    let initials = '';
    if (!addressFormJson.person.initials?.includes('.')) {
      addressFormJson.person.initials.split('').forEach(letter => initials = initials + letter.toUpperCase());
    } else {
      initials = addressFormJson.person.initials.toUpperCase();
    }
    if (required) {
      let salutation : AddressCode[];
      salutation = this.salutations.filter(sal => sal.key === addressFormJson?.person?.salutation);
      subscriptionAddress = {
        person: {
          firstname: addressFormJson?.person?.firstName,
          lastname: addressFormJson?.person?.lastName,
          email: addressFormJson?.userData?.email,
          title: this.isString(addressFormJson?.person?.title) ? addressFormJson?.person?.title : (forView ? addressFormJson?.person?.title?.description : addressFormJson?.person?.title?.key),
          salutation: salutation && salutation.length > 0 ? forView ? salutation[0].description : salutation[0].defaultClientTypeKey : this.isString(addressFormJson?.person?.salutation) ? addressFormJson?.person?.salutation : forView ? addressFormJson?.person?.salutation?.description : addressFormJson?.person?.salutation?.defaultClientTypeKey,
          initials: initials,
          middlename: addressFormJson?.person.middlename
        },
        address: {
          street: addressFormJson?.address?.street,
          houseno: this.buildHouseNo(addressFormJson, forView),
          zipcode: addressFormJson?.address?.zipcode,
          city: addressFormJson?.address?.city,
          addrExtraLine1: addressFormJson?.address?.extraLine,
          country: this.isString(addressFormJson?.address?.country) ? addressFormJson?.address?.country : (forView ? addressFormJson?.address?.country?.description : addressFormJson?.address?.country?.key),
          district: addressFormJson?.address?.district
        },
        validDate: {
          validFrom,
          validUntil
        },
        userBackendId: this.userData?.userBackendId ?? -1
      };
    }

    return subscriptionAddress;
  }

  buildHouseNo(addressFormJson, forView : boolean) : string {
    let houseNoString = '';

    let isAustria = this.isString(addressFormJson?.address?.country) ?
      addressFormJson?.address?.country === 'A' :
      addressFormJson?.address?.country?.key === 'A';
    if(!forView) {
      houseNoString = isAustria ? '01#' : '00#';
    }
    let separator = forView? '/' : '#';
    houseNoString = houseNoString + addressFormJson?.address?.houseNo;
    if ( isAustria ) {
      houseNoString = houseNoString +
        separator + addressFormJson?.address?.stiege +
        separator + addressFormJson?.address?.stock +
        separator + addressFormJson?.address?.tuer;
    } else {
      if ( !forView) {
        houseNoString = houseNoString + '###';
      }
    }

    return houseNoString;
  }

  onClickEvent(): void {
    this.loginComponent.onClickEvent();
  }

  ngOnDestroy(): void {
    this.authSub?.unsubscribe();
  }

  backToOverview(): void {
    this.navigationService.navigateTo(NavigationCommand.OFFER, null, true);
  }

  setStartDate(): void {
    this.paymentFormGroup.get('startdate').setValue(this.minDate);
    this.selectedStartDate = this.minDate;
  }

  loadMoreBonuses(): void {
    this.maxBonuses = this.maxBonuses + this.bonusReload;
  }

  ngAfterViewInit(): void {
    this.isWinback = false;
    console.debug('View is being initialized');
    setTimeout(() => {
      console.debug('View is fully loaded');
      if(isPlatformBrowser(this.platformId)) {
        this.isLoadingView = false;
      }
    }, 0);
  }

  onCardClick(formOfPayment: FormOfPayment): void {
    if (formOfPayment) {
      this.paymentFormGroup.get('formOfPayment').patchValue(formOfPayment);
    } else {
      this.paymentFormGroup.get('formOfPayment').patchValue(null);
    }
  }

  onRegisterNext($event, stepper: MatStepper): void {
    const passwordControl = this.loginFormGroup.get('password');
    const emailControl = this.loginFormGroup.get('email');
    if (!this.registerPasswordVisible) {
      emailControl.markAsPending();
    }
    const emailToCheck = emailControl.value;
    OfferDetailComponent.lastEmailInput = emailToCheck;

    CustomValidators.checkIfEmailExists(emailToCheck, this.http, this.translationService)
      .subscribe(data => {
        emailControl.updateValueAndValidity(); // hide input-spinner
        if (data !== null) {
          this.router.navigate(['/login'], {queryParams: {returnUrl: this.router.url, prefillUsername: emailToCheck}})
            .then(() => null);
        } else {
          this.registerPasswordVisible = this.registerPasswordVisibleConf && true;
          if (this.registerPasswordVisible) {
            if (!this.firstTry) {
              passwordControl.updateValueAndValidity({onlySelf: true});
            }
            if (passwordControl.valid) {
              stepper.next();
            } else if (this.firstTry) {
              setTimeout(() => {
                this.firstTry = false;
                passwordControl.enable();
                passwordControl.setErrors(null);
                passwordControl.setValidators(this.passwordInputValidators);
              }, 0);
            }
          } else {
            stepper.next();
          }
        }
      });
  }

  /**
   * transferiert die IBAN vom IBAN-Feld zum Barprämien-IBAN-Feld, um dem User den Bestellprozess zu erleichtern.
   * Funktioniert NUR in eine Richtung- es ist immer noch möglich die IBAN im Prämienfeld anzupassen
   */
  transferIban() {
    if(this.moneyBonusSelected || this.nonMoneyBonusWithClientCoPaymentSelected) {
      this.paymentFormGroup.get('ibanBonus').setValue(this.paymentFormGroup.get('iban').getRawValue());
    }
  }

  getPasswordComplexityHint(): string {
    let firstPart = '', middlePart = [], lastPart = '';
    const pwCpx = this.passwordComplexity;

    // ToDo: translations
    if (pwCpx) {
      if (parseInt(pwCpx.minLength)) {
        firstPart = 'mindestens ' + pwCpx.minLength + ' Zeichen';
      }
      if (parseInt(pwCpx.lowerChars)) {
        middlePart.push(pwCpx.lowerChars + ' Kleinbuchstaben');
      }
      if (parseInt(pwCpx.upperChars)) {
        middlePart.push(pwCpx.upperChars + ' Großbuchstaben');
      }
      if (parseInt(pwCpx.digits)) {
        middlePart.push(pwCpx.digits + ' Ziffern');
      }
      if (parseInt(pwCpx.specialChars)) {
        middlePart.push(pwCpx.specialChars + ' Sonderzeichen');
      }
      lastPart = middlePart.length > 1 ? middlePart.pop() : lastPart;
    }

    return firstPart + (firstPart.length && middlePart.length ? ', bestehend aus ' : '') + middlePart.join(', ') + (lastPart.length ? ' und ' : '') + lastPart;
  }

  getPasswordErrorMessage(): string {
    let msg = [];
    const pw = this.loginFormGroup.get('password');
    ['minLength', 'lowerChars', 'upperChars', 'digits', 'specialChars'].forEach( k => {
      pw.hasError(k) ? msg.push(pw.getError(k)) : null;
    });

    return (msg.length ? 'noch ' : '') + msg.join(', ');
  }

  /**
   * prüft, ob ein User angemeldet ist und wenn nein (Neukunde) werden die Felder Birthday und Phone je nach Konfiguration auf Required
   * gesetzt. Felder sollen überhaupt nur required sein, wenn man nicht angemeldet ist, sonst bleibt der Bestandskunde bei der Bestellung
   * stecken. Außerdem, nur wenn BEIDE booleans auf true gesetzt sind Felder required machen.
   * Wenn ein E-Paper vorliegt, müssen andere Felder gesetzt werden.
   */
  evaluatePhoneAndBirthdayFields(offer:Offer) {
    if (!this.isAuthenticated && offer.offerType != undefined) {
      if (offer.offerType.ePaper) {
        if (this.isPhoneRequired && this.askForPhone) {
          this.setPhoneFieldsRequired('billingAddress');
        }
      } else if(!offer.offerType.ePaper){
        if (this.isPhoneRequired && this.askForPhone) {
          this.setPhoneFieldsRequired('deliveryAddress');
        }
        if (this.isBirthdayRequired && this.askForBirthday) {
          this.addressFormGroup.get('deliveryAddress.userData.birthDay').setValidators(Validators.required);
        }
      }
    }
  }

  private setPhoneFieldsRequired(form: string) {
    this.addressFormGroup.get(form + '.userData.phone').addValidators(Validators.required);
    this.addressFormGroup.get(form + '.userData.phone').updateValueAndValidity();
  }

  protected readonly BonusType = BonusType;

  public getVisibleSummaryBlocks(): any[] {
    const blocks = [];

    this.hasAddressInfo('delivery') ? blocks.push('delivery') : null;
    this.hasAddressInfo('billing') ? blocks.push('billing') : null;
    this.hasAddressInfo('bonus') ? blocks.push('bonus') : null;
    blocks.push('payment', 'duration');
    this.offerPrice ? blocks.push('price') : null;

    return blocks;
  }

  public isLastBlockFullWidth(index: number): boolean {
    const blocks = this.getVisibleSummaryBlocks();
    return blocks.length % 2 === 1 && index === blocks.length - 1;
  }

  public getBlockTitle(type: string): string {
    // @formatter:off
    switch (type) {
      case 'delivery': return this.translationService.getTranslation('address_delivery');
      case 'billing': return this.translationService.getTranslation('address_billing');
      case 'bonus': return this.translationService.getTranslation('address_bonus');
      case 'payment': return this.translationService.getTranslation('payment_rhythm');
      case 'duration': return this.translationService.getTranslation('step_orderDateAndOptins');
      case 'price': return this.translationService.getTranslation('price');
      default: return '';
    }
    // @formatter:on
  }

  public getBlockContent(type: string): SafeHtml {
    let content: string;
    // @formatter:off
    switch (type) {
      case 'delivery': content = this.getAddressInfo('delivery'); break;
      case 'billing': content = this.getAddressInfo('billing'); break;
      case 'bonus': content = this.getAddressInfo('bonus'); break;
      case 'payment': content = this.getPaymentInfo(); break;
      case 'duration': content = this.getDurationInfo(); break;
      case 'price': content = this.getPriceInfo(); break;
      default: content = ''; break;
    }
    // @formatter:on

    return this.sanitizer.bypassSecurityTrustHtml(content);
  }

  private hasAddressInfo(type: 'delivery' | 'billing' | 'bonus') {
    return !!this.getAddressInfo(type);
  }

  private getAddressInfo(type: 'delivery' | 'billing' | 'bonus') {
    const person = this.addressFormGroup.get(type + 'Address.person').getRawValue();
    const userData = this.addressFormGroup.get(type + 'Address.userData').getRawValue();
    const address = this.addressFormGroup.get(type + 'Address.address').getRawValue();

    const personIsEmpty = Object.values(person).every(value => typeof value == 'object' || value === '');
    const userDataIsEmpty = ['phonecode', 'phone'].every(key => (userData[key] ?? '') === '');
    const addressIsEmpty = Object.values(address).every(value => typeof value == 'object' || value === '');

    if (personIsEmpty && userDataIsEmpty && addressIsEmpty) {
      return '';
    }

    return [
      (person.salutation.description + ' ' + (person.title.description ?? '') + ' ' + person.firstName + ' ' + person.lastName).trim(),
      (address.street + ' ' + this.houseNoPipe.transform(address.houseNo)).trim(),
      address.extraLine,
      (address.zipcode + ' ' + address.city).trim(),
      (userData.phonecode + ' ' + userData.phone).trim(),
      userData.email,
    ].join('<br>')
      .replace(/undefined/g, '') // remove 'undefined'
      .replace(/ {2,}/g, ' ') // remove multi-space
      .replace(/(<br>){2,}/g, '<br>') // remove empty lines
      .replace(/^<br>/, ''); // remove a leading empty line
  }

  private getPaymentInfo() {
    const payment = this.paymentFormGroup.getRawValue();

    return [
      payment.formOfPayment.description + ' (' + payment.paymentFrequency?.description + ')',
      !!payment.iban ? 'IBAN ' + this.bankAccountPipe.transform(payment.iban) : '',
      !!payment.bic && payment.bic.trim().match(/^[A-Z\d]+$/i) ? 'BIC ' + payment.bic : ''
    ].join('<br>')
      .replace(/undefined/g, '') // remove 'undefined'
      .replace(/(<br>){2,}/g, '<br>') // replace empty lines
      .replace(/^<br>/, ''); // remove a leading empty line
  }

  private getDurationInfo() {
    return [
      this.translationService.getTranslation('startdate'),
      this.datePipe.transform(this.selectedStartDate)
    ].join(' ')
      .trim()
      .replace(/undefined/g, ''); // remove 'undefined'
  }

  private getPriceInfo() {
    let priceInfo = [];
    this.offerPrice?.forEach(price => {
      if (!!price) {
        priceInfo.push(this.offer?.priceCalculationActivated
          ? this.decimalPipe.transform(price.price, '1.2-2') + ' ' + price.currency
          : price.priceText);
        !!price.porto
          ? priceInfo.push(this.translationService.getTranslation('price_delivery') + ' ' + this.decimalPipe.transform(price.porto, '1.2-2') + ' ' + price.currency + ' ' + price.portoDescription)
          : null;
      }
    });

    return priceInfo.join('<br>')
      .replace(/undefined/g, '') // remove 'undefined'
      .replace(/^<br>/, ''); // remove a leading empty line
  }

  /**
   * prüft, ob das Geburtsdatum-Feld angezeigt werden und Pflichtfeld sein soll und setzt die entsprechenden Variablen.
   */
  private handleBirthdayField() {
    let creditCheckRequired = this.selectedBonus.some(bonus => bonus.creditCheckRequired === true);
    this.isBirthdayRequired = this.isBirthdayRequiredConst || creditCheckRequired;
    this.askForBirthday = this.askForBirthdayConst || creditCheckRequired;
  }

  /**
   * Formularwert '<Vorwahl>/<Rufnummer>' aus der ersten Telefonnummer des Bestandskunden.
   * Dieses Format liefert auch der Telefon-Validator und erwartet {@link buildDataObjectForService}.
   */
  private getPhoneFromUserData(): string {
    const phone: any = (this.userData?.phoneList as any[])?.[0];

    return !!phone ? [phone.prefixNumber, phone.telNumber].filter(part => !!part).join('/') : '';
  }

  get formValid(): boolean {
    const allFormsValid = this.addressFormGroup?.valid;
    const existingUser = this?.userData != null && this?.userData.userBackendId > 0;
    // Deaktivierte Felder sind aus der Validierung raus. Nachzutragen sind nur die entsperrten
    // (= in P7 unbekannten) Felder, und ihr Wert steht im Formular-Control, nicht in userData.
    // Ist nichts entsperrt, greift bewusst der allFormsValid-Zweig.
    const unlockedFields = [
      {control: this.addressFormGroup.get('deliveryAddress.userData.birthDay'), askedFor: this?.askForBirthday},
      {control: this.addressFormGroup.get('deliveryAddress.userData.phone'), askedFor: this?.askForPhone}
    ].filter(field => field.askedFor && field.control?.enabled);
    const unlockedFieldsFilled = existingUser && unlockedFields.length > 0
      && unlockedFields.every(field => !!field.control.value && field.control.valid);
    const differentBillingAddress = this.addressFormGroup.get('billingAddress.showAddress').value;
    const differentBonusAddress = this.addressFormGroup.get('bonusAddress.showAddress').value;

    return (unlockedFieldsFilled && !differentBonusAddress && !differentBillingAddress) || allFormsValid;
  }

  onAgbChecked($event: boolean) {
    this.agbChecked = $event;
  }
}

